import React, { useEffect } from 'react'
import { Tooltip } from 'antd';


function BrandCard({ url, name }) {
    
    return (
            <div className="w-full my-4">
                <div className="bg-white shadow rounded-lg hover:shadow-lg overflow-hidden">
                    <a>
                        <div className="py-4 px-2 my-2">
                            <img className="h-18 w-auto mx-auto" src={url} alt={name} />
                        </div>
                        {/* <div className="p-1">
                            <p className="text-sm font-bold text-gray-700 flex justify-center">
                                <a href="#" className="uppercase tracking-wide text-purple-700"> {name}</a>
                            </p>
                            <p className="text-gray-700">742 Evergreen Terrace</p>
                        </div> */}
                    </a>
                </div>
            </div>

    );
}

export default BrandCard;
